export const dataChannelWhatsapp = [
  {
    name: 'Delivered',
    total_transaction: 0,
    tooltip: 'The number of messages that have arrived but have not been read by the customer or read receipts on the customer side are deactivated (two gray ticks).'
  },
  {
    name: 'Read',
    total_transaction: 0,
    tooltip: 'The number of messages that have been read on the customer side'
  },
  {
    name: 'Submitted',
    total_transaction: 0,
    tooltip: `The number of messages that have been sent but on the customer's side still hasn't arrived`
  },
  {
    name: 'Rejected',
    total_transaction: 0,
    tooltip: 'The number of messages whose subscriber number blocks incoming messages and the subscriber number does not have a WhatsApp account'
  },
  {
    name: 'Failed',
    total_transaction: 0,
    tooltip: 'Number of messages in which the contact data contains variables that are not perfectly generated and or the destination number is not a number that is in the coverage area or the number is dummy / random input'
  },
]
export const dataChannelSMS = [
  {
    name: 'Sent',
    total_transaction: 0,
    tooltip: 'The number of SMS that have just arrived at the operator has not been sent to the destination number'
  },
  {
    name: 'Delivered',
    total_transaction: 0,
    tooltip: 'The number of SMS that have arrived at the operator and have been sent to the destination number'
  },
  {
    name: 'Submitted',
    total_transaction: 0,
    tooltip: `the SMS provider hasn't responded with a final acceptance / rejection response yet`
  },
  {
    name: 'Failed',
    total_transaction: 0,
    tooltip: 'Number of SMS that were not sent because of an unknown error'
  },
]
export const dataChannelSMSOTP = [
  {
    name: 'Sent',
    total_transaction: 0,
    tooltip: 'The number of SMS that have just arrived at the operator has not been sent to the destination number'
  },
  {
    name: 'Delivered',
    total_transaction: 0,
    tooltip: 'The number of SMS that have arrived at the operator and have been sent to the destination number'
  },
  {
    name: 'Submitted',
    total_transaction: 0,
    tooltip: `the SMS provider hasn't responded with a final acceptance / rejection response yet`
  },
  {
    name: 'Undelivered',
    total_transaction: 0,
    tooltip: 'The number of SMS that have arrived at the operator and have been sent to the destination number'
  },
  {
    name: 'Failed',
    total_transaction: 0,
    tooltip: 'Number of SMS that were not sent because of an unknown error'
  },
]
export const dataChannelEmail = [
  {
    name: 'Delivered',
    total_transaction: 0,
    tooltip: 'The number of emails that have been sent to customers'
  },
  {
    name: 'Opened',
    total_transaction: 0,
    tooltip: 'Messages that opened by recipient.'
  },
  {
    name: 'Clicked',
    total_transaction: 0,
    tooltip: 'Messages that clicked by recipient.'
  },
  // {
  //   name: 'Failed',
  //   total_transaction: 12003,
  //   tooltip: 'Unprocessed messages, internal error when hot smtp server categorized to this failed, this is unbilled messages.'
  // },
  {
    name: 'Failed',
    total_transaction: 0,
    tooltip: 'Unprocessed messages, internal error when hot smtp server categorized to this failed, this is unbilled messages.'
  },
  {
    name: 'Failed by mail server',
    total_transaction: 0,
    tooltip: 'Bounces, deffered, dropped messages categorized to this failed.'
  }
]
export const dataChannelCall = [
  {
    name: 'In Call',
    total_transaction: 0,
    tooltip: 'The number of calls is in progress.'
  },
  {
    name: 'Answered',
    total_transaction: 0,
    tooltip: 'Number of calls based on contacts that have been answered/picked up by the telephone recipient'
  },
  {
    name: 'RNA',
    total_transaction: 0,
    tooltip: 'Number of calls sent but not answered and rejected.'
  },
  {
    name: 'Failed',
    total_transaction: 0,
    tooltip: 'The number of calls that failed to be made by the system'
  },
]
export const dataChannelVoice = [
  {
    name: 'In Call',
    total_transaction: 0,
    tooltip: 'tooltip'
  },
  {
    name: 'Answered',
    total_transaction: 0,
    tooltip: 'Number of calls based on contacts that have been answered/picked up by the telephone recipient'
  },
  {
    name: 'RNA',
    total_transaction: 0,
    tooltip: 'Lorem ipsum dolor sit metmaet lorem lorem lorem'
  },
  {
    name: 'Failed',
    total_transaction: 0,
    tooltip: 'The number of calls that failed to be made by the system'
  },
]